import { useEffect, useRef } from "react";

// Timeline heat strip: 0 = clean, 1 = strong suspected leakage. Click to seek.
export const HeatStrip = ({ values = [], color = "#F43F5E", progress = 0, onSeek, testId, height = 14 }) => {
  const canvasRef = useRef(null);
  const wrapRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current, wrap = wrapRef.current;
    if (!canvas || !wrap) return;
    const draw = () => {
      const w = wrap.clientWidth, dpr = window.devicePixelRatio || 1;
      canvas.width = w * dpr; canvas.height = height * dpr;
      canvas.style.width = `${w}px`; canvas.style.height = `${height}px`;
      const ctx = canvas.getContext("2d");
      ctx.scale(dpr, dpr);
      ctx.fillStyle = "#0B0E14"; ctx.fillRect(0, 0, w, height);
      const n = values.length;
      if (n) {
        const bw = w / n;
        for (let i = 0; i < n; i++) {
          const v = values[i];
          if (v <= 0.05) continue;
          ctx.globalAlpha = Math.min(1, 0.15 + v * 0.95);
          ctx.fillStyle = color;
          ctx.fillRect(i * bw, 0, Math.max(1, bw), height);
        }
        ctx.globalAlpha = 1;
      }
      ctx.fillStyle = "#F1F5F9"; ctx.fillRect(progress * w - 0.5, 0, 1.5, height);
    };
    draw();
    const ro = new ResizeObserver(draw); ro.observe(wrap);
    return () => ro.disconnect();
  }, [values, color, progress, height]);
  return (
    <div ref={wrapRef} data-testid={testId} className="w-full cursor-crosshair rounded-sm overflow-hidden border border-[#1c2433] mt-1"
      onClick={(e) => { const r = wrapRef.current.getBoundingClientRect(); onSeek?.((e.clientX - r.left) / r.width); }}>
      <canvas ref={canvasRef} />
    </div>
  );
};
